import React, { useEffect, useState, useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import { saveUTMParams } from '../UTMManager'
import { useLocation } from 'react-router-dom'
import { fetchLimitedAccountInfo } from '../store/userSlice'
import { trackPageView, trackLimitedLogin } from '../analytics'
import { useDispatch } from 'react-redux'

const PageviewContext = React.createContext()

export default function RouteChangeHandler({ children }) {
  const location = useLocation()
  const dispatch = useDispatch()
  const [category, setCategory] = useState()
  const locationRef = useRef()

  useEffect(() => {
    if (location.pathname !== locationRef.current) {
      window.scrollTo(0, 0)
    }

    const timeout = setTimeout(() => {
      trackPageView(category)
    }, 500)
    saveUTMParams()

    const urlParams = new URLSearchParams(document.location.search)
    const userId = urlParams.get('user_id')
    if (userId) {
      dispatch(fetchLimitedAccountInfo(userId)).then(() => {
        trackLimitedLogin(userId)
      })
    }

    locationRef.current = location.pathname

    return () => {
      clearTimeout(timeout)
    }
  }, [location.pathname, category])

  return (
    <PageviewContext.Provider value={{ category, setCategory }}>
      {React.Children.only(children)}
    </PageviewContext.Provider>
  )
}

RouteChangeHandler.propTypes = {
  children: PropTypes.node,
}

export function withPageViewCategory(category) {
  return function(PageComponent) {
    function PageViewCategory(props) {
      const { setCategory } = useContext(PageviewContext)

      useEffect(() => {
        setCategory(category)
        return () => setCategory(undefined)
      }, [])

      return <PageComponent {...props} />
    }

    return PageViewCategory
  }
}
